<template>
  <!-- eslint-disable vue/no-v-html -->
  <span
    v-if="isHtml"
    :style="`display: ${message ? 'block' : 'none'}`"
    class="form-error text-break"
    role="alert"
    v-html="message"
  />

  <span
    v-else
    :style="`display: ${message ? 'block' : 'none'}`"
    class="form-error text-break"
    role="alert"
  >
    {{ message }}
  </span>
</template>

<script>
export default {
  props: {
    isHtml: Boolean,

    message: {
      type: String,
      required: true,
      default: "",
    },
  },
};
</script>
